import type { ThemeOptions } from '@mui/material/styles';

const darkTheme: ThemeOptions = {
  palette: {
    mode: 'dark',
  },
  // palette: {
  //   mode: 'dark',
  //   background: { default: '#1A1B1D' },
  //   primary: {
  //     dark: '#0032C8',
  //     main: '#2B5BFC',
  //     light: '#4979FF',
  //   },
  //   secondary: {
  //     main: '#131925',
  //   },
  //   text: {
  //     placeholder: '#595E6B',
  //     secondary: '#62687A',
  //     primary: '#FFFFFF',
  //     contrast: '#FFFFFF',
  //   },
  //   overlay: '#080D18',
  //   overlayPopup: '#080D18CC',
  //   divider: '#282D3D',
  //   dividerHover: '#353A48',
  //   success: {
  //     main: '#02BC9C',
  //     dark: '#008B6E',
  //     light: '#103A3D',
  //   },
  //   warning: {
  //     main: '#FF8A65',
  //     dark: '#C75B39',
  //     light: '#423032',
  //   },
  //   error: {
  //     main: '#F47373',
  //     dark: '#BD4248',
  //     light: '#402B35',
  //   },
  //   info: {
  //     main: '#2196F3',
  //     dark: '#0069C0',
  //     light: '#16324E',
  //   },
  //   action: {
  //     disabled: 'white',
  //     disabledBackground: '#223B8C',
  //   },
  //   colors: {
  //     pink: '#F06292',
  //     purple: '#BA68C8',
  //     deepPurple: '#9575CD',
  //     indigo: '#7986CB',
  //     blue: '#64B5F6',
  //     teal: '#4DB6AC',
  //     orange: '#FFB74D',
  //     deepOrange: '#FF8A65',
  //   },
  // },
  // typography: {
  //   fontFamily: "'Inter', sans-serif",
  //   h1: {
  //     fontSize: '1.5rem',
  //     fontWeight: 600,
  //   },
  //   h2: {
  //     fontSize: '1rem',
  //     fontWeight: 600,
  //   },
  //   h3: {
  //     fontSize: '0.875rem',
  //     fontWeight: 500,
  //   },
  //   button: {
  //     fontSize: '0.875rem',
  //     fontWeight: 600,
  //   },
  //   body1: {
  //     fontSize: '0.875rem',
  //     fontWeight: 400,
  //   },
  //   caption: {
  //     fontSize: '0.75rem',
  //     fontWeight: 500,
  //   },
  // },
};
export default darkTheme;
